import { render } from "./ClipartComponent.vue?vue&type=template&id=eb0cfdbe&scoped=true"
import script from "./ClipartComponent.vue?vue&type=script&lang=js"
export * from "./ClipartComponent.vue?vue&type=script&lang=js"

import "./ClipartComponent.vue?vue&type=style&index=0&id=eb0cfdbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb0cfdbe"]])

export default __exports__